<template>

	<div class="content">
		<header>
			<div>
				<h1><span>淮滨县5G工业互联网运行监测平台</span></h1>
				<a target="_blank" href="http://fq.szjuxi.cn/fzq/bigdataRecordHuaibin/index.html">纺织中心</a>
				</div>
		</header>
		<section class="mainbox">
			<!--格子1-->
			<div class="listbox one_box">

				<div class="panel one_top">
					<div class="one_boxa">
						<h1>云织造</h1>
						<div>
							<ul>
								<li><span><em>97</em></span>
									<p>企业数量</p>
								</li>
								<li><span><em style="font-size:34px;">10696</em></span>
									<p>总机台数</p>
								</li>
								<li><span><em>{{datalist.kaiJiLv}}%</em></span>
									<p>开机率</p>
								</li>
							</ul>
						</div>

					</div>
					<div class="one_boxb">
						<div class="fl">
							<h1>织机类型</h1>
							<div id="myChart7" :style="{margin:'0px 0 0 -20px'}"></div>
						</div>
						<div class="fr">
							<h1>工人数量</h1>
							<div>
								<ul>
									<li><i></i><em>挡车工</em><span>{{datalist.dangCheGong}}</span></li>
									<li><i></i><em>机修工</em><span>{{datalist.jiXiuGong}}</span></li>
									<li><i></i><em>机修工</em><span>{{datalist.shangZhouGong}}</span></li>
									<li><i></i><em>验布工</em><span>{{datalist.yanBuGong}}</span></li>
								</ul>

							</div>
						</div>

					</div>
					<div class="one_boxc">
						<h1>行业平均效率  <span>单位(万米)</span></h1>
						<ul>
							<div id="myChart1" :style="{height:'440px', margin:'-5px 0 5px 0px'}"></div>
						</ul>

					</div>

					<div class="panel-footer"></div>
				</div>

			</div>

			<!--格子2-->
			<div class="listbox two_box">

				<div class="panel two_top">
					<div class="two_tit">
						<div>
							<ul><span>2020</span>
								<li>
								<h2>121418<em>万米</em></h2>
									<p>2020年度产量</p>
								</li>
							</ul>
						</div>
						<div>
							<ul><span>2021</span>
								<li>
									<h2>138708 <em>万米</em></h2>
									<p>2021年度产量</p>
								</li>
							</ul>
						</div>
					</div>
					<div class="panel-footer"></div>
				</div>

				<div class="panel two_mid">
					<h1>2021年度产量趋势  <span>单位(万米)</span></h1>
					<div class="tb_box" id="myChart6"></div>
					<div class="panel-footer"></div>
				</div>

				<div class="panel two_bot">
					<h1>产品产量  </h1>
					<!-- <span>上月 单位(万米)</span> -->
					<div class="cl_date">
						<ul v-for="(item,i) in productList.slice(0,5)" :key="i">
							<h2>{{item.chanPinMing}}</h2>
							<li>
								<dl>
									<dd :style="{width:(item.chanLiang/productList[0].chanLiang*100)+'%'}"></dd>
								</dl>
								<span>{{item.chanLiang}}</span>
							</li>
						</ul>

					</div>
					<div class="panel-footer"></div>
				</div>

			</div>

			<!--格子3-->
			<div class="listbox three_box">

				<div class="panel three_top">
					<div class="three_top_a">
						<h2>订单跟踪</h2>
						<p>本年度单数</p>
						<ul>
							<li><span v-if="datalist.benNianDuDanShu">{{datalist.benNianDuDanShu.substring(0,1)}}</span>
								<span v-if="datalist.benNianDuDanShu" :style="datalist.benNianDuDanShu.length<2?'display:none;':datalist.benNianDuDanShu.length>2?'display:inline-block':''">{{datalist.benNianDuDanShu.substring(1,2)}}</span>
								<span v-if="datalist.benNianDuDanShu" :style="datalist.benNianDuDanShu.length<3?'display:none;':datalist.benNianDuDanShu.length>3?'display:inline-block':''">{{datalist.benNianDuDanShu.substring(2,3)}}</span>
								<span v-if="datalist.benNianDuDanShu" :style="datalist.benNianDuDanShu.length<4?'display:none;':datalist.benNianDuDanShu.length>4?'display:inline-block':''">{{datalist.benNianDuDanShu.substring(3,4)}}</span>
								<span v-if="datalist.benNianDuDanShu" :style="datalist.benNianDuDanShu.length<5?'display:none;':datalist.benNianDuDanShu.length>5?'display:inline-block':''">{{datalist.benNianDuDanShu.substring(4,5)}}</span>
								<span v-if="datalist.benNianDuDanShu" :style="datalist.benNianDuDanShu.length<6?'display:none;':datalist.benNianDuDanShu.length>6?'display:inline-block':''">{{datalist.benNianDuDanShu.substring(5,6)}}</span>

							</li>
						</ul>

					</div>

					<div class="three_top_b">
						<ul>
							<li>
								<div>
									<h2>在库卷数</h2>
									<p>{{datalist.zaiKuJuanShu || 0}}</p>
								</div>
							</li>
						</ul>

						<ul>
							<li>
								<div>
									<h2>已完成单数</h2>
									<p>{{datalist.yiWanChenDanShu}}</p>
								</div>
							</li>
						</ul>

						<ul>
							<li>
								<div>
									<h2>已完成产量</h2>
									<p> {{datalist.yiWanChengChanLiang}}<span>万米</span></p>
								</div>
							</li>
						</ul>

						<ul>
							<li>
								<div>
									<h2>在库米数</h2>
									<p> {{datalist.zaiKuMiShu || 0}}<span>万米</span></p>
								</div>
							</li>
						</ul>

					</div>

					<div class="three_top_c">

						<ul>
							<h2>订单月数据</h2>
							<li>
								<div id="myChart2" :style="{height: '320px',margin:'-90px 0 0px 0px'}"></div>
							</li>
						</ul>
					</div>

					<div class="panel-footer"></div>
				</div>

				<div class="panel three_bot">

					<div class="fl">
						<h2>本月入库<img src="../../static/images/ru_i.png" alt /></h2>
						<ul>
							<li>
								<h3>{{datalist.ruKuJuanShu}}</h3>
								<p>卷数</p>
							</li>
							<li>
								<h3>{{datalist.ruKuMiShu}}</h3>
								<p>米数(万米)</p>
							</li>
						</ul>

						<h2>本月出库<img src="../../static/images/chu_i.png" alt /></h2>
						<ul>
							<li>
								<h3>{{datalist.chuKuJuanShu}}</h3>
								<p>卷数</p>
							</li>
							<li>
								<h3>{{datalist.chuKuMiShu}}</h3>
								<p>米数(万米)</p>
							</li>
						</ul>

					</div>
					<div class="fr">
						<ul>
							<li><span><em></em>入库</span><span><em></em>出库</span></li>
						</ul>

						<div id="myChart4" :style="{height: '280px',margin:'-55px 0 0 -10px'}"></div>
					</div>

					<div class="panel-footer"></div>
				</div>

			</div>

			<!--格子4-->
			<div class="listbox four_box">

				<div class="panel four_top">
					<ul><img src="../../static/images/5@2x.png" alt />
						<li>
							<h2>纺织圈APP</h2>
							<p>本年度成交</p>
						</li>
						<dl>
							<h2>{{datalist.chengJiaoDanLiang}}</h2>
							<p>单量</p>
						</dl>
						<dl>
							<h2>{{datalist.chengJiaoMiShu}}<span>万+</span></h2>
							<p>米数</p>
						</dl>
						<dl>
							<h2>{{datalist.chengJiaoJinE}}<span>万元</span></h2>
							<p>金额</p>
						</dl>
					</ul>
					<div class="tb_div">

						<div id="myChart3" :style="{height: '460px'}"></div>
					</div>

					<div class="panel-footer"></div>
				</div>

				<div class="panel four_bot">
					<div class="yun_top">
						<ul>
							<li>
								<h2 >云工厂</h2></li>
							<dl>
								<h2>{{datalist.yiJieDingDan}}</h2>
								<p>已接订单</p>
							</dl>
							<dl>
								<h2>{{datalist.dingDanChanPin}}</h2>
								<p>订单产品</p>
							</dl>
							<dl>
								<h2>{{datalist.dingDanChanLiang}}<span>万米</span></h2>
								<p>订单产量</p>
							</dl>
						</ul>
					</div>

					<div class="yun_date">

						<ul v-for="(item,i) in yunGongChangList.slice(0,5)" :key="i">
							<h2>{{item.yunGongChangName}}</h2>
							<li>
								<dl>
									<dd :style="{width:(item.wanChengShuLiang/item.dingDanShuLaing*100)+'%'}"></dd>
								</dl>
								<span>{{item.wanChengShuLiang}}/{{item.dingDanShuLaing}}</span>
							</li>
						</ul>

					</div>

					<div class="panel-footer"></div>
				</div>

			</div>

			<!--格子5-->
			<div class="listbox five_box">

				<div class="panel">
					<div class="five_boxa">
						<h1>纺配云商城</h1>
						<div>
							<ul><label>今日订单量</label>
								<li>
									<ol>
										<span v-if="data.todayOrderNum">{{data.todayOrderNum.substring(0,1)}}</span>
										<span v-if="data.todayOrderNum" :style="data.todayOrderNum.length<2?'display:none;':data.todayOrderNum.length>2?'display:inline-block':''">{{data.todayOrderNum.substring(1,2)}}</span>
										<span v-if="data.todayOrderNum" :style="data.todayOrderNum.length<3?'display:none;':data.todayOrderNum.length>3?'display:inline-block':''">{{data.todayOrderNum.substring(2,3)}}</span>
										<span v-if="data.todayOrderNum" :style="data.todayOrderNum.length<4?'display:none;':data.todayOrderNum.length>4?'display:inline-block':''">{{data.todayOrderNum.substring(3,4)}}</span>

										<em>单</em></ol>
								</li>
							</ul>
							<ul><label>今日成交额</label>
								<li>
									<ol>

										<span v-if="data.todayTotalPrice">{{data.todayTotalPrice.substring(0,1)}}</span>
										<span v-if="data.todayTotalPrice" :style="data.todayTotalPrice.length<2?'display:none;':data.todayTotalPrice.length>2?'display:inline-block':''">{{data.todayTotalPrice.substring(1,2)}}</span>
										<span v-if="data.todayTotalPrice" :style="data.todayTotalPrice.length<3?'display:none;':data.todayTotalPrice.length>3?'display:inline-block':''">{{data.todayTotalPrice.substring(2,3)}}</span>
										<span v-if="data.todayTotalPrice" :style="data.todayTotalPrice.length<4?'display:none;':data.todayTotalPrice.length>4?'display:inline-block':''">{{data.todayTotalPrice.substring(3,4)}}</span>
										<span v-if="data.todayTotalPrice" :style="data.todayTotalPrice.length<5?'display:none;':data.todayTotalPrice.length>5?'display:inline-block':''">{{data.todayTotalPrice.substring(4,5)}}</span>
										<span v-if="data.todayTotalPrice" :style="data.todayTotalPrice.length<6?'display:none;':data.todayTotalPrice.length>6?'display:inline-block':''">{{data.todayTotalPrice.substring(5,6)}}</span>
										<em>元</em></ol>
								</li>
							</ul>
							<ul><label>今日成交客户</label>
								<li>
									<ol>
										<span v-if="data.todayCustomerNum">{{data.todayCustomerNum.substring(0,1)}}</span>
										<span v-if="data.todayCustomerNum" :style="data.todayCustomerNum.length<2?'display:none;':data.todayCustomerNum.length>2?'display:inline-block':''">{{data.todayCustomerNum.substring(1,2)}}</span>
										<span v-if="data.todayCustomerNum" :style="data.todayCustomerNum.length<3?'display:none;':data.todayCustomerNum.length>3?'display:inline-block':''">{{data.todayCustomerNum.substring(2,3)}}</span>
									</ol>
								</li>
							</ul>

						</div>

					</div>
					<div class="five_boxb">
						<h1>年度数据</h1>
						<ul>
							<li>
								<dl><img src="../../static/images/renyuan@2x.png" alt />
									<dd>
										<h2>{{data.yearCustomerNum}}</h2>
										<p>客户数</p>
									</dd>
								</dl>
							</li>

							<li>
								<dl><img src="../../static/images/niandu@2x.png" alt />
									<dd>
										<h2>{{data.yearSaleNum}}<span>万元</span></h2>
										<p>本年度成交额</p>
									</dd>
								</dl>
							</li>

							<li>
								<dl><img src="../../static/images/peij@2x.png" alt />
									<dd>
										<h2>{{data.yearKindNum}}<span>+</span></h2>
										<p>配件品类</p>
									</dd>
								</dl>
							</li>

						</ul>

					</div>
					<div class="five_boxc">
						<h2>2021年销售金额统计</h2>
						<div class="tb_box">
							<div id="myChart5" :style="{height: '420px',margin:'-20px 0 0 -20px'}"></div>
						</div>
					</div>

					<div class="panel-footer"></div>
				</div>

			</div>

			<!--格子6-->
			<div class="listbox six_box">

				<div class="panel">
					<div class="six_boxa">
						<h1>原料涨跌幅</h1>
						<div class="list_div">

							<ul>
								<li>商品名称</li>
								<li>价格</li>
								<li>日涨跌幅</li>
							</ul>

							<ul v-for="(item,index) in rawList" :key="index">
								<li>{{item.yuanLianMing}}</li>
								<li>{{item.jiaGe}}</li>
								<li><span :style="item.riZhangDieFu<0?'background:#218D1D;':item.riZhangDieFu>0?'background:#EE3535;':''">{{item.riZhangDieFu}}</span></li>
							</ul>

						</div>

					</div>
					<div class="six_boxb">

						<h1>染整、后整理工序</h1>
						<div class="tb_box">
							<div id="myChart8" :style="{height: '750px',margin:'-80px 0 0 0'}"></div>
						</div>

					</div>
					<div class="panel-footer"></div>
				</div>

			</div>

		</section>

	</div>
</template>

<script>
	import $ from "jquery";

	export default {
		name: "DataCenter",

		data() {
			return {

				maxmin: {
					//柱状图 最大值最小值
					min: 0,
					max: 100
				},
				areaStyle: {
					change: {
						color: {
							type: "linear",
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [{
									offset: 0,
									color: "#0978b5" // 0% 处的颜色
								},
								{
									offset: 1,
									color: "transparent" // 100% 处的颜色
								}
							],
							global: false // 缺省为 false
						}
					},
					change2: {
						color: {
							type: "linear",
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [{
									offset: 0,
									color: "#813762" // 0% 处的颜色
								},
								{
									offset: 1,
									color: "transparent" // 100% 处的颜色
								}
							],
							global: false // 缺省为 false
						}
					},
					normal: {
						opacity: 0.1,
						color: "#98ACFF"
					},
					none: {
						color: "transparent"
					}
				}, //折线图 面积样式 种类
				xseries: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
				yseries: [12, 52, 41, 52, 63, 12, 74, 45, 85, 74, 96, 12],
				datalist: "", //所有数据总和
				yunGongChangList: "", //云工厂
				productList: "", //产品产量
				rawList: "", //原料涨跌幅
				data: "",

			};
		},
		mounted() {
			this.getData();
		},

		created() {},
		destroyed() {},
		methods: {
			getData() {
				// 当日产量 本月产量 月产能
				this.$axios({
						method: "post",
						url: "https://fpwx.51zhaobu.com/api/showInfor/getShowInfor"
					})
					.then(res => {
						// console.log(res.data);
						this.data = res.data.data;
						// this.monthSaleList = res.data.data.monthSaleList;     
						var salePrice = [];
						var yueFen = [];
						var newdata = [];

						for(var i = 0; i < res.data.data.monthSaleList.length; i++) {
							salePrice.push(
								Number(res.data.data.monthSaleList[i].salePrice)
							);
							yueFen.push(res.data.data.monthSaleList[i].month);
							newdata.push(res.data.data.monthSaleList[i].month);
						}
						var lisitem = [];
						for(var i = 0; i < salePrice.length; i++) {
							if(salePrice[i] == 0) {
								lisitem.push(i);
							}
						}
						for(var i = 0; i < lisitem.length; i++) {
							salePrice.splice(lisitem[i] - i, 1);
							newdata.splice(lisitem[i] - i, 1);
						}

						console.log(res.data.data.newdata);

						// 纺配云商城
						this.Getlinecanvasa(
							"myChart5",
							"#00ccff",
							"",
							this.areaStyle.change,
							"6",
							newdata,
							salePrice
						);
					})

				this.$axios({
						method: "post",
						url: "/api/showDataCenter/getShowData"
					})
					.then(res => {
						console.log(res.data.data);

						this.datalist = res.data.data.sumData;
						this.yunGongChangList = res.data.data.yunGongChangList;
						this.productList = res.data.data.productList;
						this.rawList = res.data.data.rawList;

						// 织机类型
						var seriesdata = [];
						for(var i = 0; i < res.data.data.loomTypeList.length; i++) {
							var item = {
								value: res.data.data.loomTypeList[i].biLi,
								name: res.data.data.loomTypeList[i].zhiJiLeiXing
							};
							seriesdata.push(item);
						}
						this.Getpiecanvas("myChart7", seriesdata);

						// 染整，后整理工序
						var seriesdata2 = [];
						for(var i = 0; i < res.data.data.gongXuList.length; i++) {
							var item = {
								value: res.data.data.gongXuList[i].biLi,
								name: res.data.data.gongXuList[i].gongXuMing
							};
							seriesdata2.push(item);
						}
						// console.log(seriesdata2);
						this.Getpiecanvasb("myChart8", seriesdata2);

						var chengJiaoJinE = [];
						var chuKuMiShu = [];
						var hangYeYueXiaoLv = [];
						var ruKuMiShu = [];
						var yiWanChengShuLiang = [];
						var yueChanLiang = [];
						var yueFen = [];
						//2020图去掉0数据 未产生值的月份
						var newdata = [];

						for(var i = 0; i < res.data.data.monthDataList.length; i++) {
							chengJiaoJinE.push(
								Number(res.data.data.monthDataList[i].chengJiaoJinE)
							);
							chuKuMiShu.push(Number(res.data.data.monthDataList[i].chuKuMiShu));
							hangYeYueXiaoLv.push(
								Number(res.data.data.monthDataList[i].hangYeYueXiaoLv)
							);
							ruKuMiShu.push(Number(res.data.data.monthDataList[i].ruKuMiShu));
							yiWanChengShuLiang.push(
								Number(res.data.data.monthDataList[i].yiWanChengShuLiang)
							);
							yueChanLiang.push(
								Number(res.data.data.monthDataList[i].yueChanLiang)
							);
							yueFen.push(res.data.data.monthDataList[i].yueFen);
							newdata.push(res.data.data.monthDataList[i].yueFen);
						}

						// 2020图去掉0数据 未产生值的月份
						var lisitem = [];
						for(var i = 0; i < chengJiaoJinE.length; i++) {
							if(chengJiaoJinE[i] == 0) {
								lisitem.push(i);
							}
						}
						for(var i = 0; i < lisitem.length; i++) {
							chengJiaoJinE.splice(lisitem[i] - i, 1);
							hangYeYueXiaoLv.splice(lisitem[i] - i, 1);
							yueChanLiang.splice(lisitem[i] - i, 1);
							yiWanChengShuLiang.splice(lisitem[i] - i, 1);
							ruKuMiShu.splice(lisitem[i] - i, 1);
							chuKuMiShu.splice(lisitem[i] - i, 1);
							newdata.splice(lisitem[i] - i, 1);
						}

						// 纺织圈

						this.Getlinecanvas(
							"myChart3",
							"#59bcfb",
							"smooth:true",
							this.areaStyle.change,
							"0",
							newdata,
							chengJiaoJinE
						);
						// 行业月平均效率
						this.Getbarcanvas(
							"myChart1",
							//  "#fe5578",
							"",
							//  this.areaStyle.change2,
							// "0",
							newdata,
							hangYeYueXiaoLv,
							//this.maxmin
							"",
							0
						);
						// 订单跟踪 1 柱状图
						this.Getbarcanvas(
							"myChart2",
							"#98ACFF",
							newdata,
							yiWanChengShuLiang,
							"",
							0
						);
						// 仓库 本月入库
						this.Getlinecanvasb(
							"myChart4",
							"#98ACFF",
							"",
							this.areaStyle.none,
							"0",
							newdata,
							ruKuMiShu,
							chuKuMiShu
						);

						// 2020年度产量趋势
						this.Getlinecanvas(
							"myChart6",
							"#fe5578",
							"smooth:true",
							this.areaStyle.change2,
							"1",
							newdata,
							yueChanLiang
						);
					})
					.catch(error => {
						console.log(error);
					});
			},
			// 折线图
			Getlinecanvas(
				item,
				color,
				smooth,
				areaStyle,
				triggerwidth,
				arryX,
				arryY,
				maxmin
			) {
				//1.图表id 2.图表颜色 3.是否平滑 4.是否有面积 5.提示框要不要竖线(线的粗细) 6.X轴标签 7.y轴数据 8.最大值最小值
				let myChart = this.$echarts.init(document.getElementById(item));
				// 绘制图表
				myChart.setOption({
					// 提示框
					tooltip: {
						trigger: "axis", // 触发类型，默认数据触发，见下图，可选为：'item' ¦ 'axis'
						backgroundColor: "rgba(0,0,0,0.8)", // 提示背景颜色，默认为透明度为0.7的黑色
						// 接受数组分别设定上右下左边距，同css
						axisPointer: {
							// 坐标轴指示器，坐标轴触发有效
							type: "line", // 默认为直线，可选为：'line' | 'shadow'
							lineStyle: {
								// 直线指示器样式设置
								color: "#fe5578",
								width: triggerwidth,
								type: "solid"
							}
						}
						// textStyle: {
						//   color: "#fff"
						// }
					},

					// 是否缩放
					// dataZoom: [
					//   {
					//     type: "inside"
					//   }
					// ],
					// 网格
					grid: {
						x: 120,
						y: 60,
						x2: 30,
						y2: 60
					},
					xAxis: {
						show: true,
						// boundaryGap: false,//x轴是否贴边
						type: "category",
						name: "",
						// 坐标轴线
						axisLine: {
							show: true,
							lineStyle: {
								color: "#c6c8cf",
								width: 2
							}
						},
						// 坐标轴标签
						axisTick: {
							show: false
						},
						// 坐标轴标签
						axisLabel: {
							margin: 35,
							color: "#beceeb",
							fontSize: 26
							// fontStyle: "normal",
							// align: "left",
						},
						data: arryX
					},
					yAxis: {
						maxmin,
						type: "value",
						// 坐标轴在 grid 区域中的分隔线。
						splitLine: {
							// show: true,
							// 背景线
							lineStyle: {
								type: 'dashed',
								color: "#c6c8cf",
								width: 2
								// opacity: 1
							}
						},
						// 坐标轴线 y
						axisLine: {
							show: false
						},
						// 坐标轴标签 y
						axisTick: {
							show: false
						},
						// 坐标轴标签
						axisLabel: {
							show: true,
							margin: 60,
							// interval: 2,
							color: "#83A5FF",
							align: "center",
							fontSize: 26
							// verticalAlign: "center"
						},
						splitNumber: 4
					},
					series: [{
						data: arryY,
						type: "line",
						smooth, //是否平滑
						areaStyle,
						symbol: 'none',
						// symbolSize:10,
						itemStyle: {
							normal: {
								// 拐点上显示数值
								// label : {
								//show: false,
								// fontSize:30,
								// offset:[0,-30],
								//  },

								lineStyle: {
									width: 4, // 设置线宽
								}
							}
						}
					}],

					lineStyle: {
						color: color
					},
					// 拐点设置
					itemStyle: {
						color: color
					}
				});
			},

			Getlinecanvasa(
				item,
				color,
				smooth,
				areaStyle,
				triggerwidth,
				arryX,
				arryY,
				maxmin
			) {
				//1.图表id 2.图表颜色 3.是否平滑 4.是否有面积 5.提示框要不要竖线(线的粗细) 6.X轴标签 7.y轴数据 8.最大值最小值
				let myChart = this.$echarts.init(document.getElementById(item));
				// 绘制图表
				myChart.setOption({
					// 提示框
					tooltip: {
						trigger: "axis", // 触发类型，默认数据触发，见下图，可选为：'item' ¦ 'axis'
						backgroundColor: "rgba(0,0,0,0.8)", // 提示背景颜色，默认为透明度为0.7的黑色
						// 接受数组分别设定上右下左边距，同css
						axisPointer: {
							// 坐标轴指示器，坐标轴触发有效
							type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
							lineStyle: {
								// 直线指示器样式设置
								color: "#acc3e2",
								width: triggerwidth,
								type: "solid"
							}
						}

					},
					grid: {
						x: 120,
						y: 60,
						x2: 30,
						y2: 60
					},
					xAxis: {
						show: true,
						// boundaryGap: false,//x轴是否贴边
						type: "category",
						name: "",
						// 坐标轴线
						axisLine: {
							show: true,
							lineStyle: {
								color: "#c6c8cf",
								width: 2
							}
						},
						// 坐标轴标签
						axisTick: {
							show: false
						},
						// 坐标轴标签
						axisLabel: {
							margin: 35,
							color: "#beceeb",
							fontSize: 26
							// fontStyle: "normal",
							// align: "left",
						},
						data: arryX
					},
					yAxis: {
						maxmin,
						type: "value",
						// 坐标轴在 grid 区域中的分隔线。
						splitLine: {
							// show: true,
							// 背景线
							lineStyle: {
								type: 'dashed',
								color: "#acc3e2",
								width: 1
								// opacity: 1
							}
						},
						// 坐标轴线 y
						axisLine: {
							show: false
						},
						// 坐标轴标签 y
						axisTick: {
							show: false
						},
						// 坐标轴标签
						axisLabel: {
							show: true,
							margin: 60,
							// interval: 2,
							color: "#becfec",
							align: "center",
							fontSize: 26
							// verticalAlign: "center"
						},
						splitNumber: 4
					},
					series: [{
						data: arryY,
						type: "line",
						smooth, //是否平滑
						areaStyle,
						// symbol:'none', 拐弯点
						symbolSize: 18,
						itemStyle: {
							normal: {

								lineStyle: {
									width: 8, // 设置线宽
								}
							}
						}
					}],

					lineStyle: {
						color: color
					},
					// 拐点设置
					itemStyle: {
						color: color
					}
				});
			},

			// 折线图2
			Getlinecanvasb(
				item,
				color,
				smooth,
				areaStyle,
				triggerwidth,
				arryX,
				arryY,
				arryY2,
				maxmin
			) {

				let myChart = this.$echarts.init(document.getElementById(item));

				myChart.setOption({

					tooltip: {
						trigger: "axis",
						backgroundColor: "rgba(0,0,0,0.8)",
						axisPointer: {
							type: "line",
							lineStyle: {
								color: "#fe5578",
								width: triggerwidth,
								type: "solid"
							}
						}
					},

					grid: {
						x: 120,
						y: 60,
						x2: 30,
						y2: 60
					},
					xAxis: {
						show: true,
						type: "category",
						name: "",
						axisLine: {
							show: true,
							lineStyle: {
								color: "#f5f5f5",
								width: 2
							}
						},
						axisTick: {
							show: false
						},

						axisLabel: {
							margin: 35,
							color: "#becfec",
							fontSize: 26
						},
						data: arryX
					},
					yAxis: {
						maxmin,
						type: "value",

						splitLine: {
							lineStyle: {
								color: "#becfec",
								width: 2
							}
						},
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							show: true,
							margin: 60,
							color: "#becfec",
							align: "center",
							fontSize: 26
						},
						splitNumber: 4
					},

					series: [{
							data: arryY,
							type: "line",
							name: "入库",
							smooth, //是否平滑
							smooth: true,
							areaStyle,
							// symbol:'none', 拐弯点
							symbolSize: 1,
							itemStyle: {
								normal: {
									// 拐点上显示数值
									label: {
										show: false,
										// fontSize:30,
										// offset:[0,-30],
									},
									lineStyle: {
										color: '#6c5ce7',
										width: 4, // 设置线宽
									}
								}
							}
						},
						{
							data: arryY2,
							type: "line",
							name: "出库",
							smooth: true,
							areaStyle,
							// symbol:'none', 拐弯点
							symbolSize: 1,
							itemStyle: {
								normal: {
									// 拐点上显示数值
									label: {
										show: false,
										// fontSize:30,
										// offset:[0,-30],
									},
									lineStyle: {
										color: '#1cd1a1',
										type: 'dotted',
										width: 4, // 设置线宽
									}
								}
							}
						}
					],

					lineStyle: {
						color: color
					},
					// 拐点设置
					itemStyle: {
						color: color
					}
				});
			},
			// 柱状图
			Getbarcanvas(item, sColor, xarry, yarry, maxmin, top) {
				// 绑定图表id  颜色  x轴 y轴 最大值最小值  最大值显示
				let myChart = this.$echarts.init(document.getElementById(item));
				// var yMax = 500;
				var dataShadow = [];

				var alltop = 0;
				for(var i = 0; i < yarry.length; i++) {
					if(yarry[i] > alltop) {
						alltop = yarry[i];
					}
				}
				// console.log(alltop)
				if(top != 100) {
					top = alltop;
				}

				myChart.setOption({
					// 提示框
					tooltip: {
						show: true, // 是否显示提示框，默认为true
						trigger: "item", // 数据项图形触发
						axisPointer: {
							// 指示样式
							type: "shadow",
							axis: "auto"
						},
						padding: 5,
						textStyle: {
							// 提示框内容的样式
							color: "#fff"
						}
					},

					// 网格
					grid: {
						x: 50,
						y: 100,
						x2: 60,
						y2: 45
					},
					xAxis: {
						data: xarry,
						axisLine: {
							show: true,
							lineStyle: {
								color: "#0433b2",
								width: 2
							}
						},

						// 坐标轴标签
						axisTick: {
							show: false
						},
						// 坐标轴标签
						axisLabel: {
							margin: 25,
							color: "#becfec",
							fontSize: 26,
							// rotate: 40, //倾斜角度
							align: "middle"
						}
					},
					yAxis: {
						maxmin,
						// interval:[0,31,50,75,100],
						// splitNumber: 4,
						axisLine: {
							show: true,
							lineStyle: {
								color: "#0433b2",
								width: 2
							}
						},

						splitLine: {
							// 背景线
							show: true,
							lineStyle: {
								color: "#0433b2",
								width: 2
							}
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: "#becfec",
								fontSize: 26
							}
						}
					},
					// dataZoom: [
					//   {
					//     type: "inside"
					//   }
					// ],
					series: [{
							stack: "chart",
							z: 3,
							// For shadow
							// name: "效率",
							type: "bar",
							itemStyle: {
								color: function(params) {
									let colorList = [
										"#6c5ce7",
										"#fe5578",
										"#6c5ce7",
										"#fe5578",
										"#6c5ce7",
										"#fe5578",
										"#6c5ce7",
										"#fe5578",
										"#6c5ce7",
										"#fe5578",
										"#6c5ce7",
										"#fe5578"
									];
									return colorList[params.dataIndex];
								},
								barBorderRadius: 20
							},
							barWidth: 15,
							data: Object.keys(yarry).map(function(key) {
								return yarry[key];
							})
						},
						// {
						//   type: "bar",
						//   stack: "chart",
						//   silent: true,
						//   itemStyle: {
						//     normal: {
						//       color: "#181C40",
						//       barBorderRadius: 20
						//     }
						//   },
						//   barGap: "-100%",
						//   barCategoryGap: "40%",
						//   data: Object.keys(yarry).map(function(key) {
						//     return top - yarry[key];
						//   }),

						//   barWidth: 15
						// }
					]
				});

				// Enable data zoom when user click bar.
			},
			//环形图
			Getpiecanvas(item, seriesdata) {
				let myChart = this.$echarts.init(document.getElementById(item));

				myChart.setOption({
					grid: {
						x: 0,
						y: 0,
						x2: 0,
						y2: 0
					},
					// backgroundColor: "#001848",//背景颜色
					color: ["#fe5578", "#19a5ff", "#faff58", "#F39543", "#A600E2"],
					series: [{
						type: "pie",
						data: seriesdata,
						radius: ["45%", "60%"],
						itemStyle: {
							normal: {
								label: {
									show: true,
									textStyle: {
										color: "#fff",
										fontSize: "18"
									},
									formatter: function(val) {
										return "{b| " + val.value + "%} \n {a|" + val.name + "}";
									},
									rich: {
										b: {
											color: "#fff",
											fontSize: 30,
											lineHeight: 48,
											align: 'center'
										},
										a: {
											color: "#fff",
											fontSize: 24,
											lineHeight: 28,
											align: 'center'
										}
									}
								},
								labelLine: {
									show: true,
									lineStyle: {
										color: "#8394C1"
									}
								}
							}
						}
					}]
				});
				// var pie = echarts.init(document.getElementById("pie"));
			},

			Getpiecanvasb(item, seriesdata) {
				let myChart = this.$echarts.init(document.getElementById(item));

				myChart.setOption({
					grid: {
						x: 20,
						y: 0,
						x2:30,
						y2: 0
					},
					// backgroundColor: "#001848",//背景颜色
					color: ["#BD10E0", "#0D7DFC", "#FF9C57", "#00FFBB", "#FFDD60"],
					series: [{
						type: "pie",
						data: seriesdata,
						
						radius: ["22%", "46%"],
						//  roseType: 'radius',
						itemStyle: {
							normal: {

								label: {
									show: true,
									textStyle: {
										color: "#fff",
										fontSize: "18"
									},
									formatter: function(val) {
										return "{b| " + val.value + "%} \n {a|" + val.name + "}";
									},
									rich: {
										b: {
											fontSize: 30,
											lineHeight: 50,
											align: 'center'
										},
										a: {
											color: "#fff",
											fontSize: 20,
											lineHeight: 30,
											align: 'center'
										}
									}
								},
								labelLine: {
									show: true,
									lineStyle: {
										color: "#8394C1"
									}
								},
								shadowBlur: 200,
								shadowColor: 'rgba(0, 0, 0, 0.5)',
							}
						}
					}]
				});
				// var pie = echarts.init(document.getElementById("pie"));
			}

		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped type='text/css'>
	html,
	div,
	span,
	applet,
	object,
	iframe,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p,
	img,
	dd,
	dt,
	dl,
	ol {
		padding: 0;
		margin: 0;
		border: none;
	}
	
	ul,
	li {
		list-style: none outside none;
		padding: 0;
		margin: 0;
	}
	
	fieldset,
	img {
		border: 0;
	}
	
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-size: 100%;
		font-weight: normal;
	}
	
	address,
	caption,
	cite,
	code,
	dfn,
	em,
	strong,
	th,
	var {
		font-style: normal;
		font-weight: normal;
	}
	
	div,
	dl,
	dt,
	dd,
	ul,
	ol,
	li,
	a,
	span,
	em,
	label {
		box-sizing: border-box;
		-webkit-box-sizing: border-box;
	}
	
	.clearfixd:after {
		content: '\20';
		display: block;
		height: 0;
		clear: both;
	}
	
	.clearfixd {
		*zoom: 1;
		overflow: hidden;
	}
	
	.content {
		width: 100%;
		// min-width: 7066px;
		//background: url(/static/images/all_bg.jpg) #0E132D no-repeat;
		background:#0E132D;
		min-height:100vh;
		background-size: 100% 100%;
		font-size: 48px;
		color: #fff;
		header {
			padding:0;
			div {
				height:250px;
				background: url(/static/images/topbg.png) no-repeat;
				background-size: 100% 60%;
				position: relative;
				h1 {padding-top: 20px;
					line-height: 60px;
					font-size: 42px;
					color: #fff;
					text-align: center;
					font-weight: bold;
					letter-spacing: 10px;
					
					transform:scale(1,1.35);
-ms-transform:scale(1,1.35);
-webkit-transform:scale(1,1.35);
                    span{ padding-left:60px;}
				}
				a{  position: absolute;right:40px; bottom:40px;	display: inline-block;  border-radius: 10px; width: 300px;
				height:80px;   background-image: linear-gradient(#005cf4, #0043b1); font-size: 32px;
    text-align: center; line-height: 80px; color:#fff; text-decoration: none; }
			}
		}
		.mainbox {
			padding: 225px 20px 10px 20px;
			min-height: 1300px;
			display: flex;
		
	transform:scale(1,1.3);
-ms-transform:scale(1,1.3);
-webkit-transform:scale(1,1.3);

			.panel {
				position: relative;
				height: 1380px;
				border: 1px solid rgba(25, 186, 139, 0.17);
				//background: rgba(255, 255, 255, 0.04) url(../../static/images/line.png); 
				background: rgba(21, 144, 255, 0.1);
				box-shadow: 0px 1px 12px 12px rgba(30, 107, 255, 0.5) inset;
				border: 1px solid #0054FF;
				padding: 30px 35px 0 35px;
				margin-bottom: 20px;
				h1 {
					line-height: 80px;
					color: #fff;
					font-size: 30px;
					span {
						opacity: 0.9;
						float: right;
						font-size: 24px;
						color: #D3E3FF;
					}
				}
			}
			.panel::before {
				position: absolute;
				top: 0;
				left: 0;
				content: "";
				width: 30px;
				height: 30px;
				border-top: 6px solid #0db8fc;
				border-left: 6px solid #0db8fc;
				border-radius: 20%;
			}
			.panel::after {
				position: absolute;
				top: 0;
				right: 0;
				content: "";
				width: 30px;
				height: 30px;
				border-top: 6px solid #0db8fc;
				border-right: 6px solid #0db8fc;
				border-radius: 20%;
			}
			.panel .panel-footer {
				position: absolute;
				left: 0;
				bottom: 0;
				width: 100%;
			}
			.panel .panel-footer::before {
				position: absolute;
				bottom: 0;
				left: 0;
				content: "";
				width: 30px;
				height: 30px;
				border-bottom: 6px solid #0db8fc;
				border-left: 6px solid #0db8fc;
				border-radius: 20%;
			}
			.panel .panel-footer::after {
				position: absolute;
				bottom: 0;
				right: 0;
				content: "";
				width: 30px;
				height: 30px;
				border-bottom: 6px solid #0db8fc;
				border-right: 6px solid #0db8fc;
				border-radius: 20%;
			}
			.listbox {
				padding: 0 10px;
			}
			.one_box {
				width: 16.55%;
			}
			.two_box {
				width: 16.55%;
			}
			.three_box {
				width: 20.25%;
			}
			.four_box {
				width: 16.55%;
			}
			.five_box {
				width: 16.55%;
			}
			.six_box {
				width: 13.55%;
			}
			.one_boxa {
				height: 430px;
				h1 {
					padding-top: 15px;
				}
				div {
					height: 335px;
					padding-top: 43px;
					border-bottom: 1px solid #508DFF;
					ul {
						display: flex;
						align-items: center;
						position: relative;
					}
					li {
						text-align: center;
						flex: 1;
						span {
							display: inline-block;
							width: 126px;
							height: 126px;
							border-radius: 50%;
							opacity: 0.8;
							background: #D385FA;
							border: 1px solid #D486FA;
							box-shadow: inset 0 2px 16px 16px rgba(30, 107, 255, 0.50);
						}
						em {
							display: inline-block;
							width: 100px;
							height: 100px;
							margin-top: 12px;
							border-radius: 50%;
							background-image: linear-gradient(180deg, #DB91FB 0%, #B558F6 100%);
							line-height: 100px;
							font-size: 40px;
						}
						p {
							line-height: 60px;
							opacity: 0.9;
							padding-top: 15px;
							font-size: 30px;
							color: #D3E3FF;
						}
					}
					li:nth-of-type(2) span {
						background: rgba(253, 225, 0, 0.50);
						border: 1px solid #F9D900;
						em {
							background-image: linear-gradient(180deg, #FB9199 0%, #F65860 100%);
							b {
								font-size: 36px;
								font-weight: normal;
							}
						}
					}
					li:nth-of-type(3) span {
						background: #FA848C;
						border: 1px solid #FA878F;
						em {
							background-image: linear-gradient(180deg, #FFE400 0%, #DDAA00 100%);
						}
					}
				}
			}
			.one_boxb {
				height: 425px;
				h1 {
					padding-top: 25px;
				}
				.fl {
					width: calc(60% - 10px);
					float: left;
					div {
						height: 320px;
					}
				}
				 .fr {
					width: 40%;
					float: right;
					div {
						height: 320px;
						ul {
							padding-top: 8px;
							li {
								display: flex;
								height: 72px;
								padding-top: 6px;
								align-items: center;
								position: relative;
								i {
									display: inline-block;
									width: 24px;
									height: 24px;
									background: #6C5CE7;
									border-radius: 4px;
								}
								em {
									display: inline-block;
									width: 42%;
									text-align: right;
									padding-right: 5px;
									opacity: 0.9;
									font-size: 20px;
									color: #D3E3FF;
								}
								span {
									font-size: 32px;
									color: #FFFFFF;
								}
							}
							li:nth-of-type(2) i {
								background: #D385FA;
							}
							li:nth-of-type(3) i {
								background: #01B8FF;
							}
							li:nth-of-type(4) i {
								background: #F8D900;
							}
						}
					}
				}
			}
			.one_boxc {
				height: 465px;
				h1 {
					padding-bottom: 0px
				}
				ul {
					height: 385px;
					position: relative;
					div {
						position: absolute;
						top: -50px;
						left: 0;
						right: 0;
					}
				}
			}
			.two_top {
				height: 200px;
				padding-left:25px;
				padding-right:5px;
				.two_tit {
					display: flex;
					align-items: center;
					position: relative;
					div {
						height: 100px;
						position: relative;
						flex: 1;
						margin-top: 20px;
						ul {
							display: flex;
							align-items: center;
							position: relative;
							span {
								display: inline-block;
								width: 80px;
								height: 80px;
								border-radius: 50%;
								background: #0161FF;
								text-align: center;
								line-height: 80px;
								font-size: 30px;
							}
							li {
								text-align: left;
								flex: 1;
								padding-left: 5px;
								h2 {
									line-height: 50px;
									padding-top: 10px;
									font-weight: bold;
									font-size: 32px;
									em {
										opacity: 0.9;
										padding-left: 2px;
										font-size: 20px;
										color: #D3E3FF;
										font-weight: normal;
									}
								}
								p {
									line-height: 40px;
									opacity: 0.9;
									font-size: 20px;
									color: #D3E3FF;
								}
							}
						}
					}
					div:first-child {
						span {
							background: #01B8FF;
						}
						&:after {
							content: '';
							position: absolute;
							z-index: 2;
							top: 10px;
							right: 0;
							width: 100%;
							height: 80px;
							border-right: 1px solid #3A99FF;
						}
					}
					div:last-child {
						padding-left: 20px;
					}
				}
			}
			.two_mid {
				height: 540px;
				.panel {
					padding: 30px 25px 20px 25px;
				}
				.tb_box {
					height: 410px;
				}
			}
			.two_bot {
				height: 600px;
				.panel {
					padding: 30px 25px 30px 25px;
				}
				.cl_date {
					height: 470px;
					ul {
						margin-top: 20px;
						h2 {
							line-height: 36px;
							font-size: 24px;
							color: #1CD1A1;
						}
						li {
							display: flex;
							align-items: center;
							position: relative;
							span {
								display: inline-block;
								width: 90px;
								text-align: right;
								font-size: 24px;
								color: #FFFFFF;
							}
							dl {
								text-align: left;
								flex: 1;
								height: 15px;
								border-radius: 7.5px;
								background-color: rgba(28, 209, 161, 0.5);
								dd {
									background: #1CD1A1;
									height: 15px;
									border-radius: 7.5px;
								}
							}
						}
					}
					ul:nth-of-type(2) {
						h2 {
							color: #FE5578;
						}
						li {
							dl {
								background-color: rgba(254, 85, 120, 0.5);
								dd {
									background: #FE5578;
								}
							}
						}
					}
					ul:nth-of-type(3) {
						h2 {
							color: #6C5CE7;
						}
						li {
							dl {
								background-color: rgba(108, 92, 231, 0.5);
								dd {
									background: #6C5CE7;
								}
							}
						}
					}
					ul:nth-of-type(4) {
						h2 {
							color: #59BCFB;
						}
						li {
							dl {
								background-color: rgba(89, 188, 251, 0.5);
								dd {
									background: #59BCFB;
								}
							}
						}
					}
					ul:nth-of-type(5) {
						h2 {
							color: #FECA57;
						}
						li {
							dl {
								background-color: rgba(254, 202, 87, 0.5);
								dd {
									background: #FECA57;
								}
							}
						}
					}
				}
			}
			.three_top {
				height: 930px;
				background: url(/static/images/mid_bg.png) no-repeat;
				background-size: 100% 100%;
				.three_top_a {
					text-align: center;
					height: 230px;
					h2 {
						line-height: 56px;
						font-size: 38.4px;
						display: inline-block;
						position: relative;
						width: 500px;
						position: relative;
						&:before {
							content: '';
							position: absolute;
							z-index: 2;
							top: 50%;
							left: 0;
							margin-top: -3px;
							width: 30%;
							height: 6px;
							display: inline-block;
							border-radius: 3px;
							background: linear-gradient(to left, #111B44, #00FFC6);
						}
						&:after {
							content: '';
							position: absolute;
							z-index: 2;
							top: 50%;
							right: 0;
							margin-top: -3px;
							width: 30%;
							height: 6px;
							display: inline-block;
							border-radius: 3px;
							background: linear-gradient(to right, #111B44, #00FFC6);
						}
					}
					p {
						line-height: 42px;
						font-size: 28.8px;
					}
					ul {
						margin: 12px auto;
						text-align: center;
						display: inline-block;
						li {
							display: flex;
							align-items: center;
							position: relative;
							span {
								display: inline-block;
								width: 80px;
								height: 80px;
								line-height: 80px;
								text-align: center;
								font-size: 54px;
								margin:12px 10px;
								background: rgba(21, 144, 255, 0.10);
								border: 1px solid #0054FF;
								box-shadow: inset 0 1px 12px 12px rgba(30, 107, 255, 0.50);
							}
						}
					}
				}
				.three_top_b {
					height: 360px;
					position: relative;
					ul {
						position: absolute;
						left: 12.8%;
						top: 190px;
						display: inline-block;
						width: 130px;
						height: 130px;
						border-radius: 50%;
						margin: 0 auto;
						text-align: center;
						background: rgba(21, 144, 255, 0.10);
						border: 1px solid #0054FF;
						box-shadow: inset 0 1px 12px 12px rgba(30, 107, 255, 0.50);
						li {
							position: relative;
							div {
								position: absolute;
								display: inline-block;
								left: -150px;
								right: -150px;
								top: 0;
								text-align: center;
							}
							h2 {
								padding-top: 24px;
								line-height: 40px;
								font-size: 20px;
							}
							p {
								line-height: 45px;
								font-size: 32px;
								span {
									font-size: 22px;
								}
							}
						}
					}
					ul:nth-of-type(2) {
						left: 30.1%;
						top: 70px;
					}
					ul:nth-of-type(3) {
						left: 52.9%;
						top: 54px;
						width: 150px;
						height: 150px;
						li {
							div {
								h2 {
									padding-top: 20px;
									line-height: 48px;
								}
							}
						}
					}
					ul:nth-of-type(4) {
						left: 70.55%;
						top: 198px;
					}
				}
				.three_top_c {
					padding: 0px 12% 10px;
					ul {
						min-height: 300px;
						background: rgba(21, 144, 255, 0.10);
						border: 1px solid #0054FF;
						h2 {
							
							line-height: 50px;
							padding-top: 10px;
							font-size: 24px;
							padding-left: 30px;
						}
						li {
							height: 240px;
						}
					}
				}
			}
			.three_bot {
				height: 430px;
				padding: 30px 15px 0 15px;
				display: flex;
				.fl {
					width: 38%;
					margin-right: 2%;
					display: inline-block;
					;
					h2 {
						line-height: 50px;
						padding: 10px 0 10px 10px;
						display: flex;
						text-align: left;
						font-size: 30px;
						img {
							width: 40px;
							height: 40px;
							margin-left: 15px;
						}
					}
					ul {
						display: flex;
						padding: 12px 0 18px;
						li {
							text-align: center;
							flex: 1;
							h3 {
								line-height: 48px;
								font-size: 36px;
							}
							p {
								line-height: 40px;
								opacity: 0.9;
								font-size: 24px;
								color: #D3E3FF;
							}
						}
					}
				}
				.fr {
					width: 60%;
					display: inline-block;
					ul {
						padding-top: 60px;
						text-align: right;
						float: right;
						padding-right: 30px;
						li {
							text-align: right;
							font-size: 18px;
							line-height: 24px;
							display: flex;
							width: 250px;
							span {
								color: #1CD1A1;
								flex: 1;
								text-align: right;
								em {
									background: #1CD1A1;
									display: inline-block;
									width: 12px;
									height: 12px;
									border-radius: 50%;
									margin-right: 10px;
								}
							}
							span:first-child {
								color: #C1B8FF;
								em {
									background: #6c5ce7;
								}
							}
						}
					}
					div {
						height: 270px;
					}
				}
			}
			.four_top {
				height: 660px;
				padding: 30px 10px 0 15px;
				ul {
					padding: 10px 0 0 5px;
					display: flex;
					 align-items: center;
					img {
						width: 72px;
						height: 72px;
						margin-right: 10px;
					}
					li {
						flex: 1;
						text-align: left;
					}
					h2 {
						height: 50px;
						line-height: 50px;
						font-size: 26px;
						span {
							font-size: 20px;
						}
					}
					p {
						line-height: 50px;
						font-size: 20px;
					}
					dl {
						display: inline-block;
						text-align: center;
						width: 20%;
						p {
							opacity: 0.9;
						}
					&:last-child{width: 22%;}	
					}
				}
			}
			.four_bot {
				height: 700px;
				padding: 30px 23px 10px 20px;
				.yun_top {
					ul {
						padding: 10px 0 0 0px;
						display: flex;
						img {
							width: 86px;
							height: 86px;
							margin-right: 20px;
						}
						li {
							flex: 1;
							text-align: left;
						}
						h2 {
							height: 50px;
							line-height: 50px;
							font-size: 26px;
							span {
								font-size: 20px;
								opacity: 0.9;
							}
						&:first-child{font-size: 32px;}		
						}
						p {
							line-height: 50px;
							font-size: 20px;
							opacity: 0.9;
						}
						dl {
							display: inline-block;
							text-align: center;
							width: 21%;
						}
					}
				}
				.yun_date {
					ul {
						margin-top: 30px;
						h2 {
							line-height: 36px;
							font-size: 24px;
							color: #1CD1A1;
						}
						li {
							display: flex;
							align-items: center;
							position: relative;
							span {
								display: inline-block;
								width: 180px;
								text-align: right;
								font-size: 24px;
								color: #FFFFFF;
							}
							dl {
								text-align: left;
								flex: 1;
								height: 15px;
								border-radius: 7.5px;
								background-color: rgba(28, 209, 161, 0.5);
								dd {
									background: #1CD1A1;
									height: 15px;
									border-radius: 7.5px;
								}
							}
						}
					}
					ul:nth-of-type(2) {
						h2 {
							color: #FE5578;
						}
						li {
							dl {
								background-color: rgba(254, 85, 120, 0.5);
								dd {
									background: #FE5578;
								}
							}
						}
					}
					ul:nth-of-type(3) {
						h2 {
							color: #6C5CE7;
						}
						li {
							dl {
								background-color: rgba(108, 92, 231, 0.5);
								dd {
									background: #6C5CE7;
								}
							}
						}
					}
					ul:nth-of-type(4) {
						h2 {
							color: #59BCFB;
						}
						li {
							dl {
								background-color: rgba(89, 188, 251, 0.5);
								dd {
									background: #59BCFB;
								}
							}
						}
					}
					ul:nth-of-type(5) {
						h2 {
							color: #FECA57;
						}
						li {
							dl {
								background-color: rgba(254, 202, 87, 0.5);
								dd {
									background: #FECA57;
								}
							}
						}
					}
				}
			}
			.five_box {
				.panel {
					padding: 30px 15px 45px;
				}
			}
			.five_boxa {
				h1 {
					padding-top: 20px;padding-left:20px;
				}
				div {
					height: 430px;
					position: relative;
					padding: 28px 0;
					ul {
						display: flex;
						margin-top: 24px;
						align-items: center;
						label {
							display: inline-block;
							width: 27%;
							font-size: 20px;
						}
						li {
							flex: 1;
							text-align: left;
							ol {
								display: flex;
								text-align: left;
							}
							span {
								display: inline-block;
								width: 68px;
								height: 68px;
								line-height: 68px;
								text-align: center;
								margin: 0 4px;
								background: rgba(21, 144, 255, 0.10);
								border: 1px solid #0054FF;
								box-shadow: inset 0 1px 12px 12px rgba(30, 107, 255, 0.50);
							}
						}
						em {
							font-size: 18px;
							vertical-align: bottom;
							line-height: 30px;
							margin-top: 36px;
							opacity: 0.9;
						}
					}
					&:before {
						content: '';
						position: absolute;
						z-index: 2;
						bottom: 0;
						left: 0;
						right: 0;
						width: 100%;
						height: 2px;
						border-radius: 0;
						background: linear-gradient(to right, #111436, #3884CF, #EAF5FF, #2A7CCD, #181239);
					}
				}
			}
			.five_boxb {
				h1 {
					padding-top: 30px; padding-left:20px;
				}
				ul {
					display: flex;
					align-items: center;
					padding: 55px 10px;
					li {
						flex: 3;
						text-align: left;
						&:nth-of-type(2) {
							flex: 4;
						}
						dl {
							display: flex;
							align-items: center;
							img {
								display: inline-block;
								width: 50px;
								height: 50px;
								margin: 0 5px 0 2px;
							}
							dd {
								flex: 1;
								text-align: left;
								h2 {
									line-height: 50px;
									font-size: 28px;
									span {
										opacity: 0.9;
										font-size: 18px;
										color: #D3E3FF;
									}
								}
								p {
									line-height: 36px;
									opacity: 0.9;
									font-size: 18px;
									color: #D3E3FF;
								}
							}
						}
					}
				}
			}
			.five_boxc {
				padding:0 0 0 20px;
				h2 {
					line-height: 60px;
					font-size: 28px;
				}
				.tb_div {
					height: 430px;
				}
			}
			.six_box {
				.panel {
					padding: 30px 10px 45px;
				}
			}
			.six_boxa {
				h1 {
					padding-top: 5px;padding-left:20px;
				}
				.list_div {
					padding: 5px 0 10px;
					ul {
						margin-top: 26px;
						padding: 0 20px;
						border-bottom: 1px solid #304F86;
						display: flex;
						align-items: center;
						font-size: 24px;
						line-height: 54px;
						li {
							flex: 8;
							text-align: left;
						}
						li:nth-of-type(2) {
							flex: 4;
						}
						li:nth-of-type(3) {
							flex: 4;
							padding-left: 25px;
						}
						span {
							display: inline-block;
							width:100%;
							height: 44px;
							line-height: 44px;
							padding: 0 5px;
							text-align: center;
						}
					}
					ul:first-child {
						background: #172F59;
						border-bottom: none;
						opacity: 0.9;
						li:nth-of-type(3) {
							flex: 4;
							padding-left: 40px;
						}
					}
				}
			}
			.six_boxb {
				
				h1 {
					padding-top: 25px;padding-left:20px;
				}
				.tb_box {
					height: 650px;	
//           transform:scale(1,1.1);
// -ms-transform:scale(1,1.1);
// -webkit-transform:scale(1,1.1);

				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/DataCenter_huaibin_big.vue